import { createStore } from "vuex";

export default createStore({
  state: {
    nav_list: [], //已打开菜单集合
    nav_index: 0, //当前菜单索引
    nva_id: 0, //当前菜单id
    components: [],
  },
  getters: {},
  mutations: {
    //存储所有组件
    setCompontents(state, data) {
      if (!state.components.includes(data)) state.components.push(data);
    },

    setLoginUser(state, data) {
      state.loginUser = data;
      // state.loginUser.is_super_auth = 1;
    },

    //初始化菜单，F5刷新后从缓存中读取菜单显示
    navInit(state) {
      const nav = localStorage.getItem("current_nav");
      let nav_list = [
        {
          path: "HomeMain",
          title: "首页",
        },
      ];
      if (nav) {
        const data = JSON.parse(nav);
        if (data.path != "HomeMain") {
          state.nav_index = 1;
        } else {
          state.nav_index = 0;
        }
        nav_list.push(data);
      }
      state.nav_list = nav_list;

      // state.nav_list = [
      //   {
      //     path: "HomeMain",
      //     title: "首页",
      //   },
      //   {
      //     path: "HuiYiDetail",
      //     title: "会议详情-合肥蜀山区开发者大会",
      //     refresh: true,
      //     data: {
      //       id: 1,
      //     },
      //     key: 0.8930522624910227,
      //   },
      //   {
      //     id: 2,
      //     path: "HuiYiList",
      //     title: "会议管理",
      //   },
      //   {
      //     path: "HuiYiDetail",
      //     title:
      //       "会议详情-会议名称会议名称会议名称会议名称会议名称会议名称会议名称会议名称会议名称会议名称会议名称",
      //     refresh: true,
      //     data: {
      //       id: 13,
      //     },
      //   },
      //   {
      //     path: "HuiYiDetail",
      //     title: "会议详情-2025华东地区消化内科学术交流大会",
      //     refresh: true,
      //     data: {
      //       id: 8,
      //     },
      //     key: 0.6940833612555005,
      //   },
      //   {
      //     path: "HuiYiDetail",
      //     title:
      //       "会议详情-合聚仁术•胃领前沿--2025中国科大胃癌规范化和个体化诊疗进展继教班",
      //     refresh: true,
      //     data: {
      //       id: 7,
      //     },
      //   },
      //   {
      //     path: "HuiYiDetail",
      //     title: "会议详情-心血管疾病专家研讨会202605",
      //     refresh: true,
      //     data: {
      //       id: 6,
      //     },
      //     key: 0.08805707065060642,
      //   },
      //   {
      //     path: "HuiYiDetail",
      //     title: "会议详情-旅行者2026年第二季度工作计划研讨会",
      //     refresh: true,
      //     data: {
      //       id: 3,
      //     },
      //   },
      // ];
      // state.nav_index = 1;
    },

    //打开菜单
    openMenu(state, data) {
      if (!data.path || !state.components.includes("c_" + data.path)) {
        let index = state.nav_list.findIndex(
          (w) => w.path == "Home404" && w.title == data.title,
        );
        if (index < 0) {
          if (state.nav_list?.length > 20) {
            ElMessage.warning("最多只能打开20个页签！");
            return false;
          }
          state.nav_list.push({
            id: data.id,
            path: "Home404",
            title: data.title,
          });
          state.nav_index = state.nav_list.length - 1;
        } else {
          state.nav_id = state.nav_list[index].id;
          state.nav_index = index;
        }
      } else {
        let index = state.nav_list.findIndex(
          (w) =>
            w.path == data.path &&
            JSON.stringify(w.data) == JSON.stringify(data.data),
        );
        if (index < 0) {
          if (state.nav_list?.length > 20) {
            ElMessage.warning("最多只能打开20个页签！");
            return false;
          }
          if (!data.title) data.title = data.name;
          state.nav_list.push(data);
          state.nav_index = state.nav_list.length - 1;
          state.nav_id = data.id;
        } else {
          state.nav_index = index;
          state.nav_id = state.nav_list[index].id;
          if (data.refresh) {
            state.nav_list[index].key = Math.random();
          }
        }
        localStorage.setItem("current_nav", JSON.stringify(data));
      }
    },

    //关闭菜单
    closeMenu(state, index) {
      state.nav_list.splice(index, 1);
      if (index <= state.nav_index) {
        state.nav_index -= 1;
      }
    },

    //关闭左侧菜单
    closeLeft(state, index) {
      state.nav_index = 1;
      state.nav_list = state.nav_list.filter((w, i) => i == 0 || i >= index);
    },

    //关闭右侧菜单
    closeRight(state, index) {
      state.nav_list = state.nav_list.filter((w, i) => i == 0 || i <= index);
      state.nav_index = state.nav_list.length;
    },

    //关闭其他
    closeOther(state) {
      state.nav_list = state.nav_list.filter(
        (w, i) => i == 0 || i == state.nav_index,
      );
      state.nav_index = 1;
    },

    //缓存当前菜单
    setCurrent(state) {
      const current_nav = state.nav_list[state.nav_index];
      localStorage.setItem("current_nav", JSON.stringify(current_nav));
    },

    //关闭全部
    closeAll(state) {
      state.nav_index = 0;
      state.nav_list = [
        {
          path: "HomeMain",
          title: "首页",
        },
      ];
      localStorage.removeItem("current_nav");
    },

    //刷新当前标签
    refresh(state) {
      state.nav_list[state.nav_index].key = Math.random();
    },
  },
  actions: {},
  modules: {},
});
